var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.queueID},[_vm._v("\n    "+_vm._s(_vm.getCallersCount)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }